import img1 from '../images/category/category-1.jpg'
import img2 from '../images/category/category-2.jpg'
import img3 from '../images/category/category-3.jpg'
import img4 from '../images/category/category-4.jpg'
import img5 from '../images/category/category-5.jpg'
import img6 from '../images/category/category-6.jpg'

const dataCategory = [
    {
        img: img1,
        title: 'Browse By Template',
        desc: 'Sed ut perspiciatis unde omnis natus error sit voluptatem',
        classpd: ''
    },
    {
        img: img2,
        title: 'UI Template',
        desc: 'Sed ut perspiciatis unde omnis natus error sit voluptatem',
        classpd: 'pl-19'
    },
    {
        img: img3,
        title: 'Graphics Design',
        desc: 'Sed ut perspiciatis unde omnis natus error sit voluptatem',
        classpd: 'pl-40'
    },
    {
        img: img4,
        title: 'Social Network',
        desc: 'Sed ut perspiciatis unde omnis natus error sit voluptatem',
        classpd: 'mg-bt-0 '
    },
    {
        img: img5,
        title: 'Browse By Template',
        desc: 'Sed ut perspiciatis unde omnis natus error sit voluptatem',
        classpd: 'mg-bt-0 pl-19'
    },
    {
        img: img6,
        title: 'Browse By Template',
        desc: 'Sed ut perspiciatis unde omnis natus error sit voluptatem',
        classpd: 'mg-bt-0 pl-40'
    },
]

export default dataCategory;
